export const createSummaryNotesContinueBtnDataSet = { cy: 'summary-notes-continue-btn' };
export const summaryNotesInputValueDataSet = { cy: 'create-summary-notes-input' };
export const confirmDeleteSummaryNoteDataSet = { cy: 'confirm-delete-summary' };
